// extracted by mini-css-extract-plugin
module.exports = {"challengeEmptyStateWrapper":"ChallengeEmptyState_challengeEmptyStateWrapper__Noas2","challengeEmptyStateBody":"ChallengeEmptyState_challengeEmptyStateBody__TdeHa"};